import { cn } from '@/lib/utils';

function colorForScore(score: number): string {
  if (score >= 90) return 'bg-grade-a/10 text-grade-a';
  if (score >= 75) return 'bg-grade-b/10 text-grade-b';
  if (score >= 60) return 'bg-grade-c/10 text-grade-c';
  if (score >= 40) return 'bg-grade-d/10 text-grade-d';
  return 'bg-grade-f/10 text-grade-f';
}

export interface DimensionCardProps {
  name: string;
  score: number;
  explanation: string;
  evidence: string[];
  className?: string;
}

export function DimensionCard({ name, score, explanation, evidence, className }: DimensionCardProps) {
  return (
    <article
      className={cn(
        'rounded-lg border bg-card p-5 shadow-sm transition-shadow hover:shadow-md',
        className,
      )}
    >
      <header className="flex items-center justify-between">
        <h3 className="text-base font-semibold text-card-foreground">{name}</h3>
        <span
          className={cn(
            'rounded-full px-3 py-1 font-mono text-sm font-semibold',
            colorForScore(score),
          )}
        >
          {score}
        </span>
      </header>
      <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{explanation}</p>
      {evidence.length > 0 && (
        <footer className="mt-4 space-y-1.5 border-t border-border pt-3">
          {evidence.map((item, i) => (
            <p key={i} className="font-mono text-xs italic text-muted-foreground">
              &ldquo;{item}&rdquo;
            </p>
          ))}
        </footer>
      )}
    </article>
  );
}
